import React, { createContext, useContext, useState, useCallback } from "react";
import { getTokenApi } from "../services/Api/login";
import { apiCredentials } from "../services/Config";

export const AuthContext = createContext({})

export default function AuthProvider({ children }) {
    const [isSignUp, setIsSignUpState] = useState(false)
    const [tokenApi, setTokenApi] = useState("")
    const [tokenUser, setTokenUser] = useState("")
    const [emailUser, setEmailUser] = useState("")
    const [roleUser, setRoleUserState] = useState("")
    const [isAdminUser, setIsAdminUser] = useState(false)
    const [isFirstLogin, setIsFirstLogin] = useState(true)
    const [loginType, setLoginType] = useState(null);

    const getNewTokenApi = async () => {
        jsonToken = await getTokenApi(apiCredentials)
        setTokenApi(jsonToken.token)
        return jsonToken.token;
    };

    // Wrapper for setIsSignUp that clears roleUser and isAdminUser on logout
    const setIsSignUp = useCallback((value) => {
        setIsSignUpState(value);
        if (!value) {
            // Clear roleUser and isAdminUser when logging out
            setRoleUserState("");
            setIsAdminUser(false);
        }
    }, []);

    // Keep backward compatibility with the typo in setter name
    const setRolelUser = useCallback((value) => {
        setRoleUserState(value);
    }, []);

    // Helper to check if current user is admin - now references isAdminUser state
    const isAdmin = isAdminUser;

    return <AuthContext.Provider value={{
        isSignUp, setIsSignUp,
        tokenApi, setTokenApi,
        tokenUser, setTokenUser,
        emailUser, setEmailUser,
        isFirstLogin, setIsFirstLogin,
        getNewTokenApi, roleUser,
        setRolelUser,
        loginType, setLoginType,
        isAdmin, isAdminUser, setIsAdminUser
    }}>
        {children}
    </AuthContext.Provider>
}